module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand1-2f6bf1fa4537d42d5940c4a8e54a0996.jpg";